<div class="container" fxLayout="column" fxLayoutAlign="space-between center" fxFill>
  
  <router-outlet></router-outlet>

  <footer class="footer">
    <p>
      Built by <a href="https://www.researchsoftware.co.il/"> The Research Software Company</a>
    </p>
  </footer>
</div>

